import styled from 'styled-components'

export const Container = styled.div`
  background-color: #fff;
  border-radius: 0.7rem;
  align-items: center;
  width: 17rem;
  padding: 1rem;
  height: fit-content;
`

export const HeaderDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const HeaderText = styled.h3`
  font-weight: 700;
  font-size: clamp(1.15rem, calc(1.15rem + 0.1vw), 2.4rem);
  font-family: 'Inter', sans-serif;
`

export const HeaderPlusDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.84rem;
  cursor: pointer;

  :hover{
      background-color: #F4F4F4;
  }
`

export const HeaderPlusImg = styled.img`
  width: 0.92rem;
`

export const StructuresDiv = styled.div`
  display: flex;
  flex-direction: column;

  .notLast:after{
    content: '';
    position: absolute;
    background: #EBEBEB;
    width: 12rem;
    height: 1px;
    left: 0.92rem;
    top: 2.1rem;
  }
`

export const StructureDiv = styled.div`
  display: flex;
  border-bottom: 1px solid #EBEBEB;
  padding: .5rem 0;
  position: relative;
  align-items: center;
  justify-content: space-between;
`

export const StructureText = styled.p`
  font-size: 400;
  font-size: clamp(0.7rem, calc(0.7rem + 0.1vw), 1.4rem);
  font-family: 'Inter', sans-serif;
  width: 70%;
  overflow-x: hidden;
`

export const StructureDotsDiv = styled.div`
  display: flex;
  margin-right: 0.41rem;
  justify-content: center;
  align-items: center;
  border-radius: 1.84rem;
  cursor: pointer;
  height: 1.84rem;

  :hover{
      background-color: #F4F4F4;
  }
`

export const StructureDotsImg = styled.img`
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`
